/* eslint-disable no-useless-concat */
import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import OptionHeaders from "../options";
import {axios} from '../../common'
const { token, baseUrl } = OptionHeaders();
const DICTIONARY_SHOW = "dictionary/show";
const DICTIONARY_GET_MULTI_LANG = "dictionary/getMultiLang";

export const showDictionary = createAsyncThunk(
  DICTIONARY_SHOW,
  async (payload, thunkAPI) => {
    try {
      const dataSource = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Dictionary`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
          },
        }),
        // expand: ["Navigation"],
        // if payload.length > 0, then filter Navigation/text eq 'payload'
        filter:
          payload.length > 0 ? ["ItemCode eq " + "'" + payload + "'" + ""] : [],
      });
      return dataSource;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getMultiLang = createAsyncThunk(
  DICTIONARY_GET_MULTI_LANG,
  async (thunkAPI) => {
    try {
      const { data } = await axios.get(`GetAllDictionary`);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
